import { render, staticRenderFns } from "./loginIDaaS.vue?vue&type=template&id=227405a3"
import script from "./loginIDaaS.vue?vue&type=script&lang=js"
export * from "./loginIDaaS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports